import { RouteItem } from '@eastcoal/router/types/route'

import { WAYBILL_LIST_PAGE_PATH } from './constants/path'
import {
  WAYBILL_LIST_ACTION_UUID,
  WAYBILL_LIST_PAGE_UUID
} from './constants/uuid'

export const waybillRoute: RouteItem = {
  title: '运单列表',
  path: WAYBILL_LIST_PAGE_PATH,
  uuid: WAYBILL_LIST_PAGE_UUID,
  Component: () => import('./List/index'),
  children: [
    {
      title: '管理运单',
      uuid: WAYBILL_LIST_ACTION_UUID
    }
  ]
}
